import { IStyle } from '@fluentui/react';

import { CommonStyles } from '../../themes/themes';

export interface ISearchStyles {
  root: IStyle;
  calloutContent: IStyle;
  searchBoxContainer: IStyle;
  itemTypeCount?: IStyle;
  items?: IStyle;
  actions?: IStyle;
  loadingMessage?: IStyle;
  emptyMessage?: IStyle;
}

export interface ISearchClassNames {
  root: string;
  searchBoxContainer: string;
  calloutContent: string;
  itemTypeCount: string;
  items: string;
  actions: string;
  loadingMessage: string;
  emptyMessage: string;
}

export const searchStylesDefault: Partial<ISearchStyles> = {
  root: {},
  calloutContent: {
    paddingTop: 0,
  },
  searchBoxContainer: {
    paddingLeft: 20,
    paddingRight: 20,
  },
  itemTypeCount: {
    marginLeft: 20,
    marginRight: 20,
  },
  items: {
    marginTop: 8,
    maxHeight: 336,
    overflowY: 'auto',
  },
  actions: {
    height: 64,
    alignItems: 'center',
    ...CommonStyles.flexCenterVertically,
  },
  loadingMessage: {
    position: 'relative',
    marginTop: 8,
    height: 200,
  },
  emptyMessage: {
    position: 'relative',
    margin: '16px 0',
    height: 200,
  },
};
